import React from 'react';
import { FormNavigationB } from './components/navigation';
import { FORM_FIELDS, PAGE } from '../../../../constants';
import { GreenMessage } from './components/green.message';
import { MessageIconsType } from './components/green.message/green.message';
import { Headline } from './components/headline';
import { FullName } from './components/full.name';
import { Lock } from './components/lock';
import cn from 'classnames';
import styles from './step.module.scss';
import { useFormData, useFormStore } from '../../../../store/selectors/formStore';

interface LayoutProps {
    greenMessage?: string;
    greenMessageIcon?: string;
    navigation?: boolean;
    headline?: FE.HeadlineText;
    locked?: boolean;
    step?: number;
    onSubmit?: () => void;
    onBlur?: React.FocusEventHandler<HTMLFormElement>;
    onChange?: React.FormEventHandler<HTMLFormElement>;
}

export const Layout: React.FC<LayoutProps> = (props) => {
    const { page } = useFormStore();
    const formData = useFormData();
    const isShowFullName = Boolean(props.step && [2, 3].includes(props.step));
    const isShowHeadline = props.headline !== false && page !== PAGE.AVITO;
    const isShowNavigation = Boolean(props.navigation);

    const onSubmit: React.FormEventHandler = (event) => {
        event.preventDefault();
        return props.onSubmit && props.onSubmit();
    };

    const onBlur: React.FocusEventHandler<HTMLFormElement> = (event) => {
        return props.onBlur && props.onBlur(event);
    };

    const StepContent = (
        <>
            <div className={styles.headline_row}>
                {isShowHeadline && <Headline>{props.headline}</Headline>}
                {isShowFullName && <FullName>{formData[FORM_FIELDS.FULL_NAME]}</FullName>}
            </div>
            {isShowNavigation && <FormNavigationB className={styles['navigation-wrapper']} />}
            <form className={styles['step-view']} onSubmit={onSubmit} onBlur={onBlur} onChange={props.onChange}>
                {typeof props.greenMessage === 'string' && (
                    <GreenMessage icon={props.greenMessageIcon as MessageIconsType} text={props.greenMessage} />
                )}
                {props.children}
            </form>
        </>
    );

    return (
        <div className={cn(styles['form-wrapper'], { [styles['form-wrapper_fullscreen']]: page === PAGE.WHITELABEL })}>
            <div className={styles['step-wrapper']}>
                {props.locked && <Lock />}
                {StepContent}
            </div>
        </div>
    );
};
